module.exports = __webpack_public_path__ + "static/1-2cd695f6c966f60e8c9589a302b12c58.png";